var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreeShipping = function SvgFreeShipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    x: 2,
    y: 2,
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 17.58 12.56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.53 7.47-2.37-3.56a.3.3 0 0 0-.26-.14h-2.34V.63a.63.63 0 0 0-.63-.63H.63A.63.63 0 0 0 0 .63v8.79a.63.63 0 0 0 .63.63h.62a2.52 2.52 0 0 0 5 0h5a2.52 2.52 0 0 0 5 0h.62a.63.63 0 0 0 .63-.63V7.65a.27.27 0 0 0-.05-.18ZM3.79 11.28a1.26 1.26 0 1 1 1.25-1.25 1.26 1.26 0 0 1-1.25 1.25m7.53-2.51H5.93a2.5 2.5 0 0 0-4.33 0h-.35V1.28H11.3Zm2.47 2.51a1.26 1.26 0 0 1 0-2.51 1.26 1.26 0 1 1 0 2.51m2.52-2.51h-.35a2.5 2.5 0 0 0-2.17-1.23 2.44 2.44 0 0 0-1.25.34V5.02h1.87a.26.26 0 0 1 .25.15l1.58 2.29a.33.33 0 0 1 .07.17Zm0 0"
  })));
};
export default SvgFreeShipping;